module.exports = __webpack_public_path__ + "static/media/builderContentOne.2b5f14ef.svg";